<div class="edp-card-widget card position-relative">
    <div (click)="navigateToBenefits()">
        <div class="card-header bg-transparent" [ngClass]="{ 'pb-0': mobileSize }">
            <span class="card-title">{{ "pt.edp.edponline.widget.counter.benefits.title" | translate: { PACK: namePack } }}</span>
            <span class="card-icon">
                <i class="icon-edponline-EDP_Online_02" aria-hidden="true"></i>
            </span>
        </div>

        <div class="position-relative">
            <div id="counter-savings-chart" #chartElement></div>

            <div class="overlay">
                <div class="container-counter">
                    <span class="label">{{ "pt.edp.edponline.widget.counter.benefits.legend.has" | translate }}</span>
                    <span class="value">
                        <span class="big" [innerHTML]="counter.full_value - counter.used_value | edpDecimalSplit"></span>
                    </span>
                    <span class="label">{{ "pt.edp.edponline.widget.counter.benefits.legend.month" | translate }}</span>
                </div>
            </div>


            <div *ngIf="!mobileSize" class="overlay-chart-label" [ngClass]="{ right: counter.used_value > 0, left: !counter.used_value }">
                <span *ngIf="!counter.used_value">0,00€</span>
                <span *ngIf="counter.used_value" [innerHTML]="fullValueFormatted | edpDecimalSplit"></span>
            </div>
        </div>
        
        <div *ngIf="!mobileSize" class="subtitles d-flex align-items-center justify-content-around">
            <span class="subtitles-label d-flex align-items-center">
            <div class="subtitles-marker"></div>
            {{ "pt.edp.edponline.widget.counter.subtitle.completed" | translate }}
            </span>
            <span class="subtitles-label d-flex align-items-center">
            <div class="subtitles-marker subtitles-marker-available"></div>
            {{ "pt.edp.edponline.widget.counter.subtitle.available" | translate }}
            </span>
        </div>        
    </div>

    <div class="container-code">
        <span *ngIf="!codesLength" [innerHTML]="textCode"></span>
        <div *ngIf="codesLength > 0" class="d-flex align-items-center justify-content-between">
            <span [innerHTML]="textCode"></span>
            <div *ngIf="codesLength === 1" class="share-icon" (click)="openCodeGeneration()">
                <i class="icon-edponline-Bop-088" aria-hidden="true"></i>
            </div>
            <div *ngIf="codesLength > 1" class="arrow-icon" (click)="navigateToBenefits()">
                <i class="icon-edponline-Bas-010"></i>
            </div>
        </div>
    </div>
</div>
